module.exports = __webpack_public_path__ + "static/media/3DPPA28.e3a88f73.jpg";